"use client"
/* */
import { useContext } from 'react';
import { OverlayController } from '../../../lib/controller/overlay/OverlayController.mjs';
import { useOverlayContext } from '../../../lib/controller/overlay/context.mjs';
import invariant from 'invariant';
import { actionContext } from '../context.mjs';
import { ActionState } from './ActionState.mjs';
import { ActionExecution } from './ActionExecution.mjs';
import { ActionStateContext } from './ActionStateContext.mjs';

class ActionModel {
  state;
  needsConfirmation;
  actionProps;
  parentAction;
  confirmationModalController;
  overlayContext;
  constructor(init) {
    const {
      actionProps,
      needsConfirmation,
      parentAction,
      overlayContext,
      confirmationModalController,
      state
    } = init;
    this.actionProps = actionProps;
    this.parentAction = parentAction;
    this.confirmationModalController = confirmationModalController;
    this.needsConfirmation = needsConfirmation;
    this.overlayContext = overlayContext;
    this.state = state;
  }
  static useNew(actionProps, init = {}) {
    const parentAction = useContext(actionContext);
    const overlayContext = useOverlayContext();
    const confirmationModalController = OverlayController.useNew();
    const state = ActionState.useNew();
    return new ActionModel({
      parentAction,
      overlayContext,
      confirmationModalController,
      needsConfirmation: false,
      actionProps,
      state,
      ...init
    });
  }
  static use() {
    const c = useContext(actionContext);
    invariant(!!c, "Action context is not defined");
    ActionStateContext.useRegisterState(c.state);
    return c;
  }
  static useConfirmationAction() {
    const action = ActionModel.use();
    return new ActionModel({
      actionProps: action.actionProps,
      confirmationModalController: action.confirmationModalController,
      overlayContext: action.overlayContext,
      state: action.state,
      needsConfirmation: false,
      parentAction: ActionModel.useNew(
        {
          closeOverlay: action.confirmationModalController
        },
        {
          parentAction: action.parentAction
        }
      )
    });
  }
  getOverlayController(component) {
    const getController = (controller) => {
      return controller === void 0 ? void 0 : controller ? this.overlayContext[component] : void 0;
    };
    return getController(this.actionProps.openOverlay) ?? getController(this.actionProps.closeOverlay) ?? getController(this.actionProps.toggleOverlay);
  }
  execute = (...args) => {
    new ActionExecution(this).execute(...args);
  };
}

export { ActionModel };
//# sourceMappingURL=ActionModel.mjs.map
